<template>
  <div class="box-b">
    <div class="tab" v-if="TabStatus">
      <span
        v-for="(item, index) in tabData"
        :key="index"
        :class="tabval === item.num ? 'setectBg' : ''"
        @click="change(item, index)"
        >{{ item.name }}</span
      >
    </div>
    <div :id="chartId" class="allnav"></div>
  </div>
</template>
<script>
import echarts from "@/js/charts.js";
export default {
  props: {
    // 图表ID
    chartId: {
      type: String,
      default: "",
    },

    // tabValue
    // tabval: {
    //   type: Number,
    //   default: 7,
    // },

    // Tab状态
    TabStatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tabData: [
        {
          num: 7,
          name: "近七天",
        },
        {
          num: 30,
          name: "月",
        },
        {
          num: 365,
          name: "年",
        },
      ],
      tabval: 7,

      LineChart1: null,
      option1: {
        tooltip: {
          trigger: "item",
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月"],
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "30%"],
          name: "回收量/吨",
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(225, 225, 225, 0.1)"
            }
          }
        },
        series: [
          {
            data: [820, 932, 1100, 934, 1290],
            type: "line",
            //smooth: true,
            areaStyle: {
              opacity: 0.1,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
          },
          
        ],
      },
    };
  },
  beforeDestroy() {
    // 清理工作 避免内存泄漏
    // 销毁监听事件
    window.removeEventListener("resize", this.resizeHandler);
    //this.disposeChart();
  },
  created() {},
  mounted() {
    this.creatChart();
    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    // 图表Tab选择
    change(item, index) {
      console.log(item, index, "图表上选择的TAB");
      this.tabval = item.num;
      this.$emit("change", item, index);
    },

    // 环形饼图配置
    creatChart() {
      this.LineChart1 = echarts.init(
        document.getElementById(this.chartId),
        null,
        {
          renderer: "svg",
        }
      );
      this.LineChart1.setOption(this.option1);
    },

    resizeHandler() {
      this.LineChart1.resize();
    },

    // 销毁 Echarts 实例
    disposeChart() {
      this.LineChart1.dispose();
    },
  },
};
</script>
<style lang="scss" scoped>
  .box-b {
    width: 100%;
    height: calc(100% - 40px);
    position: relative;
    left: 0;
    bottom: 0;
  
    .tab {
      width: 100%;
      position: absolute;
      top: 10px;
      text-align: center;
      z-index: 1;
  
      span {
        display: inline-block;
        width: 51px;
        height: 23px;
        border: 1px solid #0bc4e9;
        font-size: 14px;
        line-height: 23px;
        color: #fff;
        cursor: pointer;
        margin: 5px;
        border-radius: 6px;
      }
  
      .setectBg {
        background: rgba(10, 167, 255, 0.6);
      }
    }
  }
  
</style>